import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-skill-category-ecommerce",
  "use": "icon-skill-category-ecommerce-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-skill-category-ecommerce\">\r\n  <path d=\"M5.25 8.25h13.5l-1 13H6.25l-1-13Z\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linejoin=\"round\" />\r\n  <path d=\"M8.5 9V6.5a3.5 3.5 0 0 1 7 0V9M9 13h6\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol